export function notEmptyObject<T extends Record<string, any>>(obj: T): T | null {
  return Object.values(obj).some(Boolean) ? obj : null
}
